import { c as _c } from "react/compiler-runtime";
// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
import { useMutation } from '@tanstack/react-query';
import { createUrlFromPattern } from '@cntxt/domains/access-control';
import { axiosFetch } from '@cntxt/shared/infrastructure/api/http';
import { APIReturnType } from '@cntxt/shared/infrastructure/api/routing';
import { API_BASE } from '../../../shared/constants';
import { readNotifications as APIHandler, EndpointParams, EndpointBodyParams } from '../api/readNotifications';
import { useInvalidateNotifications } from '../queries/useInvalidateNotifications';
const network = (params: Awaited<EndpointParams['params']> & {
  data: EndpointBodyParams;
}): APIReturnType<typeof APIHandler, EndpointParams> => {
  const apiUrl = createUrlFromPattern(`${API_BASE}notifications/read`, {});
  return axiosFetch({
    apiUrl,
    method: 'POST',
    body: params.data
  });
};
export const useReadNotificationsMutation = () => {
  const $ = _c(2);
  const invalidate = useInvalidateNotifications();
  let t0;
  if ($[0] !== invalidate) {
    t0 = {
      mutationFn: network,
      onSettled: () => {
        invalidate();
      }
    };
    $[0] = invalidate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};